"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This is a generated file containing an enum for the Icons.
 * This is intended to be imported into components and used to refer to icons.
 * If you wish to update this file with any new icons, please run the following command in the shared/client workspace:
 *
 * npm run process:svgs
 *
 * See https://confluence.dev.lithium.com/display/KPM/Project+Aurora+-+Icon+Guide for a full guide
 *
 * @author Rosalyn Rowe
 */
var IconTypes;
(function (IconTypes) {
    IconTypes["AccessibilityIcon"] = "accessibility";
    IconTypes["AddIcon"] = "add";
    IconTypes["AddOutlineIcon"] = "add-outline";
    IconTypes["AddSolidIcon"] = "add-solid";
    IconTypes["AddSolidOutlineIcon"] = "add-solid-outline";
    IconTypes["AiIcon"] = "ai";
    IconTypes["AnalyticsDashboardsIcon"] = "analytics-dashboards";
    IconTypes["AnalyticsReportsIcon"] = "analytics-reports";
    IconTypes["AnalyticsThirdpartyIcon"] = "analytics-thirdparty";
    IconTypes["AnchorIcon"] = "anchor";
    IconTypes["AnnouncementIcon"] = "announcement";
    IconTypes["ArchiveIcon"] = "archive";
    IconTypes["ArchiveOutlineIcon"] = "archive-outline";
    IconTypes["ArchivedIcon"] = "archived";
    IconTypes["ArrowDownIcon"] = "arrow-down";
    IconTypes["ArrowDownOutlineIcon"] = "arrow-down-outline";
    IconTypes["ArrowLeftIcon"] = "arrow-left";
    IconTypes["ArrowLeftOutlineIcon"] = "arrow-left-outline";
    IconTypes["ArrowRightIcon"] = "arrow-right";
    IconTypes["ArrowRightOutlineIcon"] = "arrow-right-outline";
    IconTypes["ArrowUpIcon"] = "arrow-up";
    IconTypes["ArrowUpOutlineIcon"] = "arrow-up-outline";
    IconTypes["ArrowUpRightIcon"] = "arrow-up-right";
    IconTypes["AttachmentIcon"] = "attachment";
    IconTypes["AttachmentOutlineIcon"] = "attachment-outline";
    IconTypes["AutosaveIcon"] = "autosave";
    IconTypes["AutosaveOutlineIcon"] = "autosave-outline";
    IconTypes["BadgeUnknownIcon"] = "badge-unknown";
    IconTypes["BadgesIcon"] = "badges";
    IconTypes["BasicsWidthofbrowserIcon"] = "basics-widthofbrowser";
    IconTypes["BasicsWidthofpageIcon"] = "basics-widthofpage";
    IconTypes["BellIcon"] = "bell";
    IconTypes["BinocularsIcon"] = "binoculars";
    IconTypes["BrowserBrowserWidthIcon"] = "browser-browser-width";
    IconTypes["BrowserFluidWidthIcon"] = "browser-fluid-width";
    IconTypes["BrowserPageContentWidthIcon"] = "browser-page-content-width";
    IconTypes["ButtonHeroIcon"] = "button-hero";
    IconTypes["ButtonLargeIcon"] = "button-large";
    IconTypes["ButtonStandardIcon"] = "button-standard";
    IconTypes["ButtonsFilledIcon"] = "buttons-filled";
    IconTypes["ButtonsOutlinedIcon"] = "buttons-outlined";
    IconTypes["ButtonsPillIcon"] = "buttons-pill";
    IconTypes["ButtonsSquareIcon"] = "buttons-square";
    IconTypes["CategoryCommonIcon"] = "category-common";
    IconTypes["CategoryContentIcon"] = "category-content";
    IconTypes["CategoryCustomIcon"] = "category-custom";
    IconTypes["CategoryPeopleIcon"] = "category-people";
    IconTypes["CategoryPlacesIcon"] = "category-places";
    IconTypes["CategoryTextHtmlIcon"] = "category-text-html";
    IconTypes["ChapterIcon"] = "chapter";
    IconTypes["CheckmarkAdminIcon"] = "checkmark-admin";
    IconTypes["CheckmarkIcon"] = "checkmark";
    IconTypes["CheckmarkInputIcon"] = "checkmark-input";
    IconTypes["CheckmarkOutlineIcon"] = "checkmark-outline";
    IconTypes["CheckmarkSolidIcon"] = "checkmark-solid";
    IconTypes["CheckmarkSolidOutlineIcon"] = "checkmark-solid-outline";
    IconTypes["ChevronDownIcon"] = "chevron-down";
    IconTypes["ChevronDownOutlineIcon"] = "chevron-down-outline";
    IconTypes["ChevronLeftIcon"] = "chevron-left";
    IconTypes["ChevronLeftOutlineIcon"] = "chevron-left-outline";
    IconTypes["ChevronRightIcon"] = "chevron-right";
    IconTypes["ChevronRightOutlineIcon"] = "chevron-right-outline";
    IconTypes["ChevronUpIcon"] = "chevron-up";
    IconTypes["ChevronUpOutlineIcon"] = "chevron-up-outline";
    IconTypes["CloseIcon"] = "close";
    IconTypes["CloseOutlineIcon"] = "close-outline";
    IconTypes["CommentIcon"] = "comment";
    IconTypes["CommentOutlineIcon"] = "comment-outline";
    IconTypes["CommunityIcon"] = "community";
    IconTypes["ContentBlogIcon"] = "content-blog";
    IconTypes["ContentCategoryIcon"] = "content-category";
    IconTypes["ContentContestIcon"] = "content-contest";
    IconTypes["ContentDiscussionIcon"] = "content-discussion";
    IconTypes["ContentDiscussionQuestionIcon"] = "content-discussion-question";
    IconTypes["ContentDiscussionSolvedIcon"] = "content-discussion-solved";
    IconTypes["ContentGroupIcon"] = "content-group";
    IconTypes["ContentIdeaIcon"] = "content-idea";
    IconTypes["ContentKnowledgeIcon"] = "content-knowledge";
    IconTypes["ContentLayoutCardIcon"] = "content-layout-card";
    IconTypes["ContentLayoutDetailedListIcon"] = "content-layout-detailed-list";
    IconTypes["ContentLayoutListIcon"] = "content-layout-list";
    IconTypes["ContentOccasionIcon"] = "content-occasion";
    IconTypes["ContentProductIcon"] = "content-product";
    IconTypes["ContentTagIcon"] = "content-tag";
    IconTypes["CoreRoleIcon"] = "core-role";
    IconTypes["CreateIcon"] = "create";
    IconTypes["CreateOutlineIcon"] = "create-outline";
    IconTypes["DangerAdminIcon"] = "danger-admin";
    IconTypes["DangerIcon"] = "danger";
    IconTypes["DangerOutlineIcon"] = "danger-outline";
    IconTypes["DesignerAssetsIcon"] = "designer-assets";
    IconTypes["DesignerChangelogIcon"] = "designer-changelog";
    IconTypes["DesignerEmailsIcon"] = "designer-emails";
    IconTypes["DesignerPagesIcon"] = "designer-pages";
    IconTypes["DesignerTextkeysIcon"] = "designer-textkeys";
    IconTypes["DesignerThemesIcon"] = "designer-themes";
    IconTypes["DeviceDesktopIcon"] = "device-desktop";
    IconTypes["DevicePhoneIcon"] = "device-phone";
    IconTypes["DeviceTabletIcon"] = "device-tablet";
    IconTypes["DownloadIcon"] = "download";
    IconTypes["DownloadOutlineIcon"] = "download-outline";
    IconTypes["DragIcon"] = "drag";
    IconTypes["DragLockIcon"] = "drag-lock";
    IconTypes["DragMoveIcon"] = "drag-move";
    IconTypes["EditIcon"] = "edit";
    IconTypes["EditOutlineIcon"] = "edit-outline";
    IconTypes["EditRedoIcon"] = "edit-redo";
    IconTypes["EditUndoIcon"] = "edit-undo";
    IconTypes["ElementsBordersDarkIcon"] = "elements-borders-dark";
    IconTypes["ElementsBordersLightIcon"] = "elements-borders-light";
    IconTypes["ElementsBordersNoneIcon"] = "elements-borders-none";
    IconTypes["ElementsInputsPillIcon"] = "elements-inputs-pill";
    IconTypes["ElementsInputsRoundedIcon"] = "elements-inputs-rounded";
    IconTypes["ElementsInputsSquareIcon"] = "elements-inputs-square";
    IconTypes["ElementsModalsDarkIcon"] = "elements-modals-dark";
    IconTypes["ElementsModalsLightIcon"] = "elements-modals-light";
    IconTypes["ElementsRadiusLargeIcon"] = "elements-radius-large";
    IconTypes["ElementsRadiusSmallIcon"] = "elements-radius-small";
    IconTypes["ElementsRadiusSquareIcon"] = "elements-radius-square";
    IconTypes["ElementsShadowsDarkIcon"] = "elements-shadows-dark";
    IconTypes["ElementsShadowsLightIcon"] = "elements-shadows-light";
    IconTypes["ElementsShadowsNoneIcon"] = "elements-shadows-none";
    IconTypes["EllipsisIcon"] = "ellipsis";
    IconTypes["EllipsisOutlineIcon"] = "ellipsis-outline";
    IconTypes["EmojiActivityIcon"] = "emoji-activity";
    IconTypes["EmojiAnimalsAndNatureIcon"] = "emoji-animals-and-nature";
    IconTypes["EmojiCustomIcon"] = "emoji-custom";
    IconTypes["EmojiFlagsIcon"] = "emoji-flags";
    IconTypes["EmojiFoodAndDrinkIcon"] = "emoji-food-and-drink";
    IconTypes["EmojiObjectsIcon"] = "emoji-objects";
    IconTypes["EmojiSmileysAndPeopleIcon"] = "emoji-smileys-and-people";
    IconTypes["EmojiSymbolsIcon"] = "emoji-symbols";
    IconTypes["EmojiTravelAndPlacesIcon"] = "emoji-travel-and-places";
    IconTypes["EnvelopeIcon"] = "envelope";
    IconTypes["ExternalLinkIcon"] = "external-link";
    IconTypes["ExternalLinkOutlineIcon"] = "external-link-outline";
    IconTypes["FaceHappyIcon"] = "face-happy";
    IconTypes["FaceHappyOutlineIcon"] = "face-happy-outline";
    IconTypes["FaceSadIcon"] = "face-sad";
    IconTypes["FaceSadOutlineIcon"] = "face-sad-outline";
    IconTypes["FeaturesFeaturesIcon"] = "features-features";
    IconTypes["FeaturesInboxIcon"] = "features-inbox";
    IconTypes["FeaturesLocalizedCategoriesIcon"] = "features-localized-categories";
    IconTypes["FeaturesModerationIcon"] = "features-moderation";
    IconTypes["FeaturesProductsIcon"] = "features-products";
    IconTypes["FeaturesSalesforceIcon"] = "features-salesforce";
    IconTypes["FeaturesSyndicationIcon"] = "features-syndication";
    IconTypes["FilterIcon"] = "filter";
    IconTypes["FlagAdminIcon"] = "flag-admin";
    IconTypes["FlagIcon"] = "flag";
    IconTypes["FlagOutlineIcon"] = "flag-outline";
    IconTypes["FollowIcon"] = "follow";
    IconTypes["FollowOutlineIcon"] = "follow-outline";
    IconTypes["FollowingIcon"] = "following";
    IconTypes["FollowingOutlineIcon"] = "following-outline";
    IconTypes["FollowsEmptyIcon"] = "follows-empty";
    IconTypes["GearIcon"] = "gear";
    IconTypes["GearOutlineIcon"] = "gear-outline";
    IconTypes["GuideIcon"] = "guide";
    IconTypes["HamburgerMenuIcon"] = "hamburger-menu";
    IconTypes["HeaderLargeIcon"] = "header-large";
    IconTypes["HeaderMediumHomeIcon"] = "header-medium-home";
    IconTypes["HeaderMediumPlaceIcon"] = "header-medium-place";
    IconTypes["HeaderSmallIcon"] = "header-small";
    IconTypes["HelpIcon"] = "help";
    IconTypes["HomeIcon"] = "home";
    IconTypes["InboxIcon"] = "inbox";
    IconTypes["InboxOutlineIcon"] = "inbox-outline";
    IconTypes["InfoAdminIcon"] = "info-admin";
    IconTypes["InfoIcon"] = "info";
    IconTypes["InfoOutlineIcon"] = "info-outline";
    IconTypes["KeyIcon"] = "key";
    IconTypes["KhorosCurlIcon"] = "khoros-curl";
    IconTypes["KhorosFullLogoIcon"] = "khoros-full-logo";
    IconTypes["KhorosLogoIcon"] = "khoros-logo";
    IconTypes["LanguageIcon"] = "language";
    IconTypes["LayoutCardIcon"] = "layout-card";
    IconTypes["LayoutClusterIconIcon"] = "layout-cluster-icon";
    IconTypes["LayoutGridIcon"] = "layout-grid";
    IconTypes["LayoutListIcon"] = "layout-list";
    IconTypes["LikeIcon"] = "like";
    IconTypes["LikeOutlineIcon"] = "like-outline";
    IconTypes["LikeRemoveIcon"] = "like-remove";
    IconTypes["LikeRemoveOutlineIcon"] = "like-remove-outline";
    IconTypes["LockIcon"] = "lock";
    IconTypes["LockOutlineIcon"] = "lock-outline";
    IconTypes["MembershipRoleIcon"] = "membership-role";
    IconTypes["MentionIcon"] = "mention";
    IconTypes["MenuIcon"] = "menu";
    IconTypes["MessagesIcon"] = "messages";
    IconTypes["MicrophoneIcon"] = "microphone";
    IconTypes["MicrophoneOutlineIcon"] = "microphone-outline";
    IconTypes["NavHighlightBackgroundIcon"] = "nav-highlight-background";
    IconTypes["NavHighlightColorIcon"] = "nav-highlight-color";
    IconTypes["NavHighlightUnderlineIcon"] = "nav-highlight-underline";
    IconTypes["NotificationIcon"] = "notification";
    IconTypes["NotificationOutlineIcon"] = "notification-outline";
    IconTypes["OverviewStructureIcon"] = "overview-structure";
    IconTypes["PanelDividedIcon"] = "panel-divided";
    IconTypes["PanelRoundedIcon"] = "panel-rounded";
    IconTypes["PanelSpacedIcon"] = "panel-spaced";
    IconTypes["PinIcon"] = "pin";
    IconTypes["PinOutlineIcon"] = "pin-outline";
    IconTypes["PoweredByKhorosLogoIcon"] = "powered-by-khoros-logo";
    IconTypes["QuoteIcon"] = "quote";
    IconTypes["RankIcon"] = "rank";
    IconTypes["RefreshIcon"] = "refresh";
    IconTypes["RefreshOutlineIcon"] = "refresh-outline";
    IconTypes["RepliesIcon"] = "replies";
    IconTypes["RestrictedIcon"] = "restricted";
    IconTypes["SearchIcon"] = "search";
    IconTypes["SearchOutlineIcon"] = "search-outline";
    IconTypes["SearchResultsIcon"] = "search-results";
    IconTypes["SectionOneColumnIcon"] = "section-1column";
    IconTypes["SectionThreeColumnIcon"] = "section-3column";
    IconTypes["SectionTwoColumnIcon"] = "section-2column";
    IconTypes["SectionWideLeftIcon"] = "section-wide-left";
    IconTypes["SectionWideRightIcon"] = "section-wide-right";
    IconTypes["SelectArrowIcon"] = "select-arrow";
    IconTypes["SendIcon"] = "send";
    IconTypes["SendOutlineIcon"] = "send-outline";
    IconTypes["SizeContractIcon"] = "size-contract";
    IconTypes["SizeContractOutlineIcon"] = "size-contract-outline";
    IconTypes["SizeExpandIcon"] = "size-expand";
    IconTypes["SizeExpandOutlineIcon"] = "size-expand-outline";
    IconTypes["StarIcon"] = "star";
    IconTypes["StarOutlineIcon"] = "star-outline";
    IconTypes["StopwatchIcon"] = "stopwatch";
    IconTypes["SubtractSolidIcon"] = "subtract-solid";
    IconTypes["SubtractSolidOutlineIcon"] = "subtract-solid-outline";
    IconTypes["SystemAccountAndPrivacyIcon"] = "system-account-and-privacy";
    IconTypes["SystemAdvancedIcon"] = "system-advanced";
    IconTypes["SystemAnnouncementsIcon"] = "system-announcements";
    IconTypes["SystemAuditIcon"] = "system-audit";
    IconTypes["SystemAuthenticationIcon"] = "system-authentication";
    IconTypes["SystemAutomationIcon"] = "system-automation";
    IconTypes["SystemDisplayIcon"] = "system-display";
    IconTypes["SystemRegistrationIcon"] = "system-registration";
    IconTypes["SystemSearchIcon"] = "system-search";
    IconTypes["SystemSeoIcon"] = "system-seo";
    IconTypes["TemplateContentIcon"] = "template-content";
    IconTypes["TemplateDashboardIcon"] = "template-dashboard";
    IconTypes["TemplateGrouphubsIcon"] = "template-grouphubs";
    IconTypes["TemplateHeaderFooterIcon"] = "template-header-footer";
    IconTypes["TemplateHomeIcon"] = "template-home";
    IconTypes["TemplateProfileIcon"] = "template-profile";
    IconTypes["TextAlignCenterIcon"] = "text-align-center";
    IconTypes["TextAlignLeftIcon"] = "text-align-left";
    IconTypes["TextAlignRightIcon"] = "text-align-right";
    IconTypes["ThemeAvatarsIcon"] = "theme-avatars";
    IconTypes["ThemeBasicsIcon"] = "theme-basics";
    IconTypes["ThemeButtonsIcon"] = "theme-buttons";
    IconTypes["ThemeColorsIcon"] = "theme-colors";
    IconTypes["ThemeElementsIcon"] = "theme-elements";
    IconTypes["ThemeFontsIcon"] = "theme-fonts";
    IconTypes["ThemeIconsIcon"] = "theme-icons";
    IconTypes["TitleBottomIcon"] = "title-bottom";
    IconTypes["TitleOverlayIcon"] = "title-overlay";
    IconTypes["TitleTopIcon"] = "title-top";
    IconTypes["TrashIcon"] = "trash";
    IconTypes["TrashOutlineIcon"] = "trash-outline";
    IconTypes["UnfollowIcon"] = "unfollow";
    IconTypes["UnfollowOutlineIcon"] = "unfollow-outline";
    IconTypes["UserIcon"] = "user";
    IconTypes["UserLockedIcon"] = "user-locked";
    IconTypes["UserOutlineIcon"] = "user-outline";
    IconTypes["UsersAddIcon"] = "users-add";
    IconTypes["UsersBadgesIcon"] = "users-badges";
    IconTypes["UsersProfileIcon"] = "users-profile";
    IconTypes["UsersRanksIcon"] = "users-ranks";
    IconTypes["UsersRolesIcon"] = "users-roles";
    IconTypes["VideoPlayActiveIcon"] = "video-play-active";
    IconTypes["VideoPlayDisabledIcon"] = "video-play-disabled";
    IconTypes["ViewsHideIcon"] = "views-hide";
    IconTypes["ViewsHideOutlineIcon"] = "views-hide-outline";
    IconTypes["ViewsIcon"] = "views";
    IconTypes["ViewsOutlineIcon"] = "views-outline";
    IconTypes["WidgetContentIcon"] = "widget-content";
    IconTypes["WidgetCustomIcon"] = "widget-custom";
    IconTypes["WidgetDynamicIcon"] = "widget-dynamic";
    IconTypes["WidgetFpoIcon"] = "widget-fpo";
    IconTypes["WidgetPeopleIcon"] = "widget-people";
    IconTypes["WidgetPlacesIcon"] = "widget-places";
    IconTypes["WidgetStaticIcon"] = "widget-static";
    IconTypes["ZoomLogoIcon"] = "zoom-logo";
})(IconTypes || (IconTypes = {}));
exports.default = IconTypes;
//# sourceMappingURL=enums.js.map